import {
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  material_code,
  amount,
  unit,
  remarks,
} from '@/table/Job/SubJob/base';

export default {
  types: {
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    material_code: {
      ...material_code,
      width: '1fr',
    },
    amount: {
      ...amount,
      name: 'จำนวนทั้งหมด',
      width: '6rem',
    },
    qc_store_amount: {
      name: 'QC ส่งให้',
      width: '5rem',
      class: 'text-right',
    },
    unit,
    remarks,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    'qc_store_amount',
    'unit',
  ],
};
